<template>
    <div class="addressInfo">
        <div>
            <div class="shopNameBlock">
                <div v-if="statusLabel" class="statusTag" :style="{ color: statusColor }">{{ statusLabel }}</div>
                <div class="shopNameText">{{shopName}}</div>
            </div>
            <div class="addressText">{{address}}</div>
        </div>
        <div class="map" :class="{ disabled: !canNavigate }" @click.stop="handleNavigate">
            <img src="@/assets/order/address.png" alt="" class="address"> 
            <div>{{distance}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name:'OrderAddress',
    props:{
        address:{
            type:String,
            default:''
        },
        shopName:{
            type:String,
            default:''
        },
        statusLabel:{
            type:String,
            default:''
        },
        statusColor:{
            type:String,
            default:'#05A558'
        },
        distance:{
            type:[String, Number],
            default:''
        },
        lat: {
            type: [String, Number],
            default: ''
        },
        lng: {
            type: [String, Number],
            default: ''
        },
    },
    computed: {
        canNavigate() {
            const lat = Number(this.lat)
            const lng = Number(this.lng)
            if (Number.isFinite(lat) && Number.isFinite(lng)) return true
            return String(this.address || '').trim().length > 0
        }
    },
    methods: {
        getNavigateUrl() {
            const lat = Number(this.lat)
            const lng = Number(this.lng)
            if (Number.isFinite(lat) && Number.isFinite(lng)) {
                return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${lat},${lng}`)}&travelmode=driving`
            }
            const addr = String(this.address || '').trim()
            if (addr) {
                return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(addr)}&travelmode=driving`
            }
            return 'https://www.google.com/maps'
        },
        handleNavigate() {
            if (!this.canNavigate) return
            const url = this.getNavigateUrl()
            if (typeof window !== 'undefined') {
                const w = window.open(url, '_blank', 'noopener,noreferrer')
                if (!w) window.location.href = url
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.addressInfo{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .shopNameBlock{
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        .shopNameText{
            color: #333;
            font-weight: 600;
        }
        .statusTag{
            font-size: inherit;
            font-weight: 600;
            line-height: 1;
        }
    }
    .addressText{
        font-size: .75rem;
        color: #666666;
        margin-top: 0.3rem;
    }
    .address{
        width: 2.125rem;
        height: 2.125rem;
        display: block;
    }

    .map{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img{
            margin-bottom: 0.5rem;
        }
    }

    .map.disabled{
        cursor: default;
    }
    
}
</style>

